/** 从 WebSocket / MobX 等异步上下文请求关闭弹窗，由 PopupProvider 在 React 树内处理 */
export const POPUP_CLOSE_REQUEST = "PopupCloseRequest"

/** 从导航等非 React 上下文请求打开图片/视频预览，由 PopupProvider 处理 */
export const OPEN_IMAGE_GALLERY = "OpenImageGallery"
